import React from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  IMdaePopupProps,
  MdaePopupFooterStartButtons,
} from "../popup";
import MdaeButton from "../button";
import { TOGGLE_CONFIRMATION_POPUP } from "../../mdae-common-reducer";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
import { ConfirmationPopupConfigParams } from "./index";
import "./index.scss";
import $ from "jquery";

interface ConfirmationPopupProps extends IMdaePopupProps {
  widgetConfigPropertyName?: string;
  reducerName?: string;
  actionType?: string;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = (props) => {
  const dispatch = useDispatch();
  const widgetConfigPropertyName =
    props.widgetConfigPropertyName || "confirmationPopupConfig";
  const widgetUpdaterReducerName = props.reducerName || "mdaeCommonReducer";
  const popupWidgetDataUpdaterConfig = props.mdaeDataUpdaterConfig || [
    {
      actionType: props.actionType || TOGGLE_CONFIRMATION_POPUP,
      reducerName: widgetUpdaterReducerName,
      widgetOptionBindings: {
        visible: widgetConfigPropertyName + ".visible",
        mdaePopupTitle: widgetConfigPropertyName + ".title",
        height: widgetConfigPropertyName + ".height",
        width: widgetConfigPropertyName + ".width",
      },
    },
  ];

  const confirmationPopupConfig: ConfirmationPopupConfigParams = useSelector(
    (state) =>
      state[popupWidgetDataUpdaterConfig[0].reducerName][
        widgetConfigPropertyName
      ],
    isEqual
  );

  const confirmationCloseHandler = () => {
    dispatch({
      type: popupWidgetDataUpdaterConfig[0].actionType,
      data: {
        visible: false,
      },
    });
  };
  const confirmationPopupTitle = () => {
    return (
      <MdaePopupTitle
        isHideCloseButton={true}
        isSmallPopup={confirmationPopupConfig?.isSmallPopup}
        closePopupHandler={() => {
          confirmationCloseHandler();
        }}
      >
      {confirmationPopupConfig?.title || "Confirmation"}
      </MdaePopupTitle>
    );
  };
  const confirmationPopupContent = () => {
    return (
      <MdaePopupContent>
        <div>
          <div className="mdae-standalone-label">
            {typeof confirmationPopupConfig?.contentHtml === "string"
              ? confirmationPopupConfig?.contentHtml
              : null}
            {typeof confirmationPopupConfig?.contentHtml === "function"
              ? confirmationPopupConfig?.contentHtml()
              : null}
          </div>
        </div>
      </MdaePopupContent>
    );
  };
  const confirmationPopupFooter = () => {
    return (
      <MdaePopupFooter>
        <MdaePopupFooterStartButtons>
          {confirmationPopupConfig?.cancelShown && (
            <MdaeButton
              id={""}
              role={"secondary"}
              onClick={confirmationPopupConfig?.onCancel}
            >
              {confirmationPopupConfig?.cancelLabel || "Cancel"}
            </MdaeButton>
          )}
          {confirmationPopupConfig?.declineShown && (
            <MdaeButton
              id={""}
              role={"secondary"}
              onClick={confirmationPopupConfig?.onDecline}
            >
              {confirmationPopupConfig?.declineLabel || "Cancel"}
            </MdaeButton>
          )}
        </MdaePopupFooterStartButtons>
        <MdaePopupFooterEndButtons>
          {confirmationPopupConfig?.confirmShown && (
            <MdaeButton
              id={""}
              role={"primary"}
              onClick={confirmationPopupConfig?.onConfirm}
            >
              {confirmationPopupConfig?.confirmLabel || "OK"}
            </MdaeButton>
          )}
        </MdaePopupFooterEndButtons>
      </MdaePopupFooter>
    );
  };

  return (
    <MdaePopup
      {...props}
      autoHeight={confirmationPopupConfig?.autoHeight ? true: false}
      mdaeContentRender={confirmationPopupContent}
      mdaeTitleRender={confirmationPopupTitle}
      mdaeFooterRender={confirmationPopupFooter}
      hideOnOutsideClick={false}
      maxHeight={600}
      onShowing={(e) => {
        e.component.registerKeyHandler("escape", function(arg) {
          arg.stopPropagation();
        });
        let isSmallPopup = false;
        if ($(e.component.content()).outerHeight(true) > 250) {
          isSmallPopup = false;
        } else {
          isSmallPopup = true;
        }
        dispatch({
          type: popupWidgetDataUpdaterConfig[0].actionType,
          data: {
            ...confirmationPopupConfig,
            isSmallPopup: isSmallPopup,
          },
        });
      }}
      showTitle={true}
      mdaeDataUpdaterConfig={popupWidgetDataUpdaterConfig}
    ></MdaePopup>
  );
};

export default ConfirmationPopup;
